import { JoeUrl, Schema } from "../../../../../@types";
import { enums } from "../../../../../../../shim/jsbridge";
import Name from "../../../../../../search/schema/components/Name";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const url: Schema<JoeUrl> = {
  fields: [
    {
      name: "k_name",
      displayTitle: "Name",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.k_name,
            int_submission_analyzer: URLANALYZER
          }}
        />
      ),
      style: { width: "30%" }
    },
    {
      name: "k_source",
      displayTitle: "Source",
      sortable: true,
      component: d => <>{d.k_source}</>,
      style: { width: "30%" }
    },
    {
      name: "k_currentpath",
      displayTitle: "Current path",
      sortable: true,
      component: d => <>{d.k_currentpath}</>,
      style: { width: "20%" }
    },
    {
      name: "k_fromMemory",
      displayTitle: "Contacted",
      sortable: true,
      component: d => <>{d.k_fromMemory === "false" ? "true" : "false"}</>,
      style: { width: "8%" }
    },
    {
      name: "k_malicious",
      displayTitle: "Malicious",
      sortable: true,
      component: d => <>{d.k_malicious}</>,
      style: { width: "8%" }
    },
    {
      name: "k_reputation",
      displayTitle: "Reputation",
      sortable: true,
      component: d => <>{d.k_reputation}</>,
      style: { width: "8%" }
    }
  ]
};
